module.exports = __webpack_public_path__ + "static/bebauung3-f6c90eab1378a7930658ab98f087d9e4.png";